const getStep = (jsonParams, { properties }) => {
  return {
    step: jsonParams?.value,
    msj: { mult: `Debe ser multiplo de ${jsonParams?.value}` },
  };
};
export default getStep;
